import useLoadingSpinner from './useLoadingSpinner';

export default useLoadingSpinner;
